<template>
  <header>
    <div class="container">
      <a href="javascript:void(0)" class="btn-menu" :class="{ '-close': showMenuMobile }" @click="showMenuMobile = !showMenuMobile"></a>

      <router-link
        to="/"
        class="logo"
        title="Fibra"
      >
        <img src="/images/logo-blue.png" alt="">

        <div class="background" />
      </router-link>

      <ul class="main-menu" :class="{ '-show': showMenuMobile }">
        <li>
          <a
            href="javascript:void(0)"
            :class="{
              active: path.includes('/status')
                || path.includes('/comunicados')
                || path.includes('/documentos')
                || path.includes('/opcao-planta')
                || path.includes('/guia-do-cliente')
                || path.includes('/perguntas-frequentes')
                || path.includes('/ficha-tecnica')
            }"
          >
            {{ menuTitle[0] || 'Meu Fibra' }}
          </a>

          <ul>
            <li v-if="$store.state.exibirStatusObra && menuData.statusObra">
              <router-link to="/status"><p></p> Status da obra</router-link>
            </li>

            <li v-if="menuData.comunicados">
              <router-link to="/comunicados" style="white-space: nowrap">
                <p></p>
                Comunicados
                <span
                  class="unread"
                  v-if="$store.state.badge && $store.state.badge > 0"
                >
                  {{ $store.state.badge }}
                </span>
              </router-link>
            </li>

            <li v-if="menuData.documentos">
              <router-link to="/documentos"><p></p> Documentos</router-link>
            </li>

            <li v-if="$store.state.exibirPersonalizacao && menuData.personalizacao">
              <router-link to="/opcao-planta"><p></p> Opção de planta</router-link>
            </li>

            <li v-if="exibirGuiaCliente">
              <router-link to="/guia-do-cliente"><p></p> Guia do Cliente</router-link>
            </li>

            <li>
              <router-link to="/perguntas-frequentes"><p></p> Perguntas Frequentes</router-link>
            </li>

            <li v-if="menuData.fichaTecnica">
              <router-link to="/ficha-tecnica"><p></p> Ficha Técnica</router-link>
            </li>
          </ul>
        </li> <!-- /MEU FIBRA -->

        <li v-if="hasFinancas">
          <a
              href="javascript:void(0)"
              :class="{
              active: path.includes('/situacao-financeira')
                || path.includes('/informe-ir')
            }"
          >
            {{ menuTitle[1] || 'Finanças' }}
          </a>

          <ul>
            <li>
              <router-link to="/situacao-financeira"><p></p> Situação financeira</router-link>
            </li>

            <li v-if="menuData.informeIR">
              <router-link to="/informe-ir"><p></p> Informe IR</router-link>
            </li>
          </ul>
        </li> <!-- /FINANCAS -->

        <li v-if="hasAtendimento">
          <a
              href="javascript:void(0)"
              :class="{ active: path.includes('/envio-mensagem') }"
          >
            {{ menuTitle[2] || 'Atendimento' }}
          </a>

          <ul>
            <!-- <li v-if="menuData.chat">
              <a href="javascript:void(0)" @click="openChat();">Chat</a>
            </li> -->

            <li v-if="menuData.envioMensagem">
              <router-link to="/envio-mensagem"><p></p> Envio de mensagem</router-link>
            </li>
          </ul>
        </li>

        <li class="-emp">
          <template v-if="isPersonificado">
            <p class="unidade" v-if="contratoAtual.exibirNomeTorre">
              {{ contratoAtual.nome }} - {{ contratoAtual.bloco }} - {{ contratoAtual.unidade }}
            </p>

            <p class="unidade" v-else>
              {{ contratoAtual.nome }} - {{ contratoAtual.unidade }}
            </p>
          </template>

          <template v-else>
            <div class="box">
              <a
                  href="javascript:void(0)"
                  @click="showUnidadeSelector = !showUnidadeSelector"
                  v-if="contratoAtual.exibirNomeTorre"
              >
                {{ contratoAtual.nome }} - {{ contratoAtual.bloco }} - {{ contratoAtual.unidade }}
              </a>

              <a
                  href="javascript:void(0)"
                  @click="showUnidadeSelector = !showUnidadeSelector"
                  v-else
              >
                {{ contratoAtual.nome }} - {{ contratoAtual.unidade }}
              </a>

              <ul class="items" :class="{ '-show': showUnidadeSelector }">
                <template v-for="item in contratos">
                  <li v-if="item.codigo !== contratoAtual.codigo" :key="item.codigo">
                    <a
                        href="javascript:void(0)"
                        :title="item.nome"
                        @click="changeUnidade(item)"
                        v-if="contratoAtual.exibirNomeTorre"
                    >
                      {{ item.nome }} - {{ item.bloco }} - {{ item.unidade }}
                    </a>

                    <a href="javascript:void(0)" :title="item.nome" @click="changeUnidade(item)" v-else>
                      {{ item.nome }} - {{ item.unidade }}
                    </a>
                  </li>
                </template>
              </ul>
            </div>
          </template>
        </li> <!-- /.-emp -->

        <li class="-user">
          <a href="javascript:void(0)" v-html="welcome"></a>

          <ul>
            <li v-if="menuData.seusDados">
              <router-link to="/seus-dados"><p></p> Cadastro</router-link>
            </li>

            <li v-if="!$store.state.personificado">
              <router-link to="/troca-senha"><p></p> Troca de senha</router-link>
            </li>

            <li>
              <a href="javascript:void(0)" @click="logout" title="Sair"><p></p> Sair</a>
            </li>
          </ul>
        </li> <!-- /.user -->
      </ul>
    </div> <!-- /.container -->
  </header>
</template>

<script>
import Auth from '@/services/Auth'

export default {
  data () {
    return {
      path: '',
      showMenuMobile: false,
      showUnidadeSelector: false
    }
  },

  watch: {
    '$route.path': function () {
      this.showMenuMobile = false
      this.showUnidadeSelector = false

      this.path = window.location.pathname
    }
  },

  mounted () {
  },

  methods: {
    logout () {
      Auth.logout()
    },

    openChat () {
      let produtoId = this.contratoAtual.empreendimentoIdWeb
      let url = `http://fibra.hypnobox.com.br/?controle=Atendimento&acao=index&produto=${produtoId || 0}&midia=`

      window.open(url, 'name', 'Location=NO, status=no, scrollbars=no, width=430, height=550, resizable=no, top=30, left=30, scrollbars=no, Titlebar=no,maximized=no')
    },

    changeUnidade (item) {
      this.$store.commit('setContratoAtual', item)
      localStorage.setItem('STORAGE.CONTRATOATUAL', JSON.stringify(item))
      this.showMenuMobile = false
      this.showUnidadeSelector = false

      setTimeout(() => {
        window.location.href = '/'
      }, 500)
    }
  },

  computed: {
    contratoAtual () {
      return this.$store.state.contratoAtual
    },

    menuData () {
      return this.$attrs.menuData || {}
    },

    exibirGuiaCliente () {
      return this.$attrs.exibirGuiaCliente || false
    },

    hasFinancas () {
      return (
        this.menuData.situacaoFinanceira ||
        this.menuData.informeIR
      )
    },

    hasAtendimento () {
      return this.menuData.chat || this.menuData.envioMensagem
    },

    welcome () {
      let str = 'Bem vindo'
      const nome = this.$store.state.nome

      if (nome) {
        const [ firstName ] = nome.split(' ')
        str += ` (a),<br> ${firstName}`
      }

      return str
    },

    menuTitle () {
      return this.$attrs.menuItems.reduce((titles, item) => {
        titles.push(item.nome)

        return titles
      }, [])
    },

    isPersonificado () {
      return this.$store.state.personificado
    },

    contratos () {
      return this.$attrs.contratos
    }
  }
}
</script>

<style lang="sass" scoped>
  @import '@/assets/sass/_base.sass'

  header
    width: 100%
    height: 80px
    position: fixed
    background: rgba(#5B8991, 0.8)
    color: #fff
    animation-fill-mode: forwards
    transition: all 250ms ease
    z-index: 2000

    &.-fixed
      background: map-get($colors, gray)

    .btn-menu
      display: none

    .container
      height: 80px
      display: flex
      justify-content: space-between
      align-items: center

    .logo
      background-repeat: no-repeat
      background-size: contain
      background-position: 0 center
      font-size: 0
      width: 300px
      height: 46px
      margin-right: 40px
      z-index: 10000
      align-items: center
      display: flex
      position: relative

      img
        height: auto
        position: relative
        top: 4px

      .background
        background: #fff
        position: absolute
        top: -17px
        right: 0
        bottom: -17px
        left: 0
        z-index: -10

        &:before
          content: ''
          background: #fff
          bottom: 0
          top: 0
          right: 100%
          width: 100vw
          position: absolute

        &:after
          content: ''
          background: #fff
          transition: all 250ms ease
          bottom: 0
          top: 0
          width: 200px
          position: absolute
          left: calc(100% - 65px)
          z-index: 100
          transform: translateX(-50%) skewX(35deg)

    .main-menu
      display: flex
      width: calc(100% - 170px)
      align-items: center
      justify-content: space-between
      height: 80px
      position: relative

      > li
        // min-width: 150px
        max-width: 250px
        position: relative
        height: 100%
        display: flex
        align-items: center
        justify-content: center
        flex-direction: column

        &:hover
          > a
            color: #e50019

          //ul
          //  li:hover
          //    background: #e50019
          //
          //    a
          //      color: #fff

        &.-emp
          max-width: initial

          .unidade
            background: #bfbfbf
            color: #000
            padding: 7px 9px
            font-size: 13px
            font-weight: 600
            white-space: nowrap

          .box
            position: relative

            > a
              position: relative
              background: #fff
              color: #5b8991
              padding: 7px 30px 7px 9px
              font-size: 13px
              font-weight: 600
              white-space: nowrap

              &:after
                content: ''
                position: absolute
                right: 12px
                top: 50%
                transform: translateY(-50%)
                width: 0
                height: 0
                border-left: 6px solid transparent
                border-right: 6px solid transparent
                border-top: 10px solid map-get($colors, primary)

            @media (min-width: 1024px)
              &:hover
                .items
                  max-height: 200px
                  border-left: 1px solid map-get($colors, gray)
                  border-right: 1px solid map-get($colors, gray)
                  border-bottom: 1px solid map-get($colors, gray)
                  background: #fff

            .items
              position: absolute
              max-height: 0
              overflow: hidden
              overflow-y: auto
              transition: all 150ms ease
              top: calc(100% + 7px)
              left: 0
              right: 0
              background: transparent
              border-left: 1px solid transparent
              border-right: 1px solid transparent
              border-bottom: 1px solid transparent

              &::-webkit-scrollbar
                width: 10px
                height: 10px

              &::-webkit-scrollbar-button
                width: 0px
                height: 0px

              &::-webkit-scrollbar-thumb
                background: lighten(map-get($colors, gray), 25%)
                border: 0px none #ffffff
                border-radius: 0px

              &::-webkit-scrollbar-thumb:hover
                background: lighten(map-get($colors, gray), 25%)

              &::-webkit-scrollbar-thumb:active
                background: lighten(map-get($colors, gray), 25%)

              &::-webkit-scrollbar-track
                background: #bfbfbf
                border: 0px none #ffffff
                border-radius: 0px

              &::-webkit-scrollbar-track:hover
                background: #bfbfbf

              &::-webkit-scrollbar-track:active
                background: #bfbfbf

              &::-webkit-scrollbar-corner
                background: transparent

              li:last-of-type a
                border-bottom: none

              a
                font-size: 13px
                padding: 8px 9px
                color: #5b8991
                display: block
                font-weight: 600
                white-space: nowrap
                border-bottom: 1px solid #efefef
                transition: all 150ms ease

                &:hover
                  background: #efefef

        &:hover
          > ul
            max-height: 380px

        > a
          text-transform: uppercase
          font-weight: bold
          font-size: 15px
          padding: 0 15px
          white-space: nowrap

          &.active
            color: #e50019

        > ul
          max-height: 0
          overflow: hidden
          transition: all 400ms ease
          background: #5b8991
          position: absolute
          top: 100%
          min-width: calc(100% + 20px)

          > li
            a
              color: #fff
              padding: 10px
              transition: all 150ms ease
              font-weight: 700
              display: block
              text-align: center
              font-size: 15px
              background: rgba(#e50019, 0)

              &.router-link-exact-active,
              &:hover
                color: #e50019

              span
                border-radius: 100%
                width: 18px
                height: 18px
                text-align: center
                font-size: 11px
                position: relative
                left: 2px
                top: -1px
                line-height: 18px
                background: map-get($colors, primary)
                display: inline-block

    @media (max-width: 1024px)
      position: fixed !important
      top: 0
      left: 0
      right: 0
      height: 60px
      background: transparent

      &:before
        display: none

      .container
        justify-content: flex-start
        height: 60px
        padding: 0
        background: #fff

      .btn-menu
        display: block
        background-position: center
        background-repeat: no-repeat
        width: 45px
        height: 100%
        background-color: #202020
        background-size: 27px auto
        background-image: url(~/images/icons/menu-bar.png)

        &.-close
          background-size: 20px auto
          background-image: url(~/images/icons/modal-close.png)

      .logo
        position: absolute
        left: 50%
        transform: translateX(-50%)
        width: 200px
        top: 5px

        .background
          display: none

      .main-menu
        // display: none
        padding-top: 15px
        padding-bottom: 50px
        position: absolute
        background: map-get($colors, gray)
        top: 60px
        left: 0
        right: 0
        bottom: 0
        height: calc(100vh - 50px)
        z-index: 100
        flex-direction: column
        opacity: 0
        overflow-y: auto
        transition: all .2s ease
        transform: translateX(100%)
        width: 100%
        max-width: 768px

        &.-show
          opacity: 1
          transform: translateX(0%)

        > li
          max-width: initial
          width: 100%
          height: auto
          padding-bottom: 10px
          margin-bottom: 10px
          border-bottom: 1px solid hsla(0,0%,100%,.3)

          &.-emp
            order: -2
            width: 100%
            max-width: initial
            margin-top: -5px
            z-index: 1233

            .items.-show
              max-height: 150px
              border-left: 1px solid #efefef
              border-right: 1px solid #efefef
              border-bottom: 1px solid #efefef
              background: #fff

          &.-user
            order: -1

            > a
              /deep/ br
                display: none

          > a
            font-size: 16px
            text-align: left
            width: 100%
            padding: 0 8px 0 10px
            font-weight: normal
            margin-bottom: 5px

          > ul
            max-height: initial
            position: relative
            top: initial

            > li
              > a
                text-align: left
                font-weight: normal
                padding: 7px 5px 7px 25px
</style>
